import { useEffect } from 'react';
import { useAuth } from '../../../modules/auth';
import useSocket from '../../../hooks/useSocket';
import { useAlertToast } from './index';

/**
 * Escuta o canal "alert" do websocket e empilha os alertas na tela,
 * respeitando as preferências do usuário.
 *
 * Fica em um componente próprio (e não no App) porque precisa estar dentro do
 * AlertToastProvider para usar o hook useAlertToast.
 */
const AlertSocketListener = () => {
  const { currentUser } = useAuth();
  const { socket, on, off } = useSocket();
  const { pushAlert } = useAlertToast();

  useEffect(() => {
    const handleEventsSocketAlert = (data: any) => {
      if (!data) return;

      const permissions = currentUser && currentUser.permissions ? currentUser.permissions : null;
      const alertScreenEnabled = !permissions || permissions.notification_alert_screen !== false;
      const alertSoundEnabled = !permissions || permissions.notification_alert_sound !== false;

      if (!alertScreenEnabled) return;

      pushAlert({
        type: data.type,
        title: data.title,
        description: data.description,
        idPlant: data.idPlant,
        plantName: data.plantName,
        createdAt: data.createdAt,
        playSound: alertSoundEnabled,
      });
    };

    if (currentUser && currentUser.id && socket) {
      on('alert', handleEventsSocketAlert);
      console.log('[ALERT] Listener do canal "alert" registrado para o usuário', currentUser.id);
    }

    return () => {
      if (socket) {
        off('alert', handleEventsSocketAlert);
      }
    };
  }, [currentUser, socket, on, off, pushAlert]);

  return null;
};

export default AlertSocketListener;
